/*
 * Copyright © 2017 - 2019 Atilika Inc. All rights reserved.
 */

import React, {memo} from "react";
import {createUseStyles} from "react-jss";
import UI from "../common/UI";

const useStyles = createUseStyles({
    root: {
        color: UI.colors.blue.toCSS(),
        fontSize: "2.25rem",
        [UI.media.only("xs")]: {
            fontSize: "1rem",
            overflow: "auto"
        },
        "& ruby": {
            rubyAlign: "center"
        },
        "& rt": {
            color: UI.colors.veryDarkGrey.toCSS(),
            fontSize: "1rem",
            margin: ({spaceRt}: KuromojiSampleProps) => (spaceRt ? "0 1rem 0.5rem" : "0 0 .5rem")
        },
        "& span": {
            color: UI.colors.veryDarkGrey.toCSS()
        },
        "& th": {
            color: UI.colors.veryDarkGrey.toCSS(),
            fontSize: "1.125rem",
            fontWeight: "normal",
            lineHeight: 2.67,
            paddingRight: "2rem",
            "&:last-child": {
                paddingRight: 0
            }
        },
        "& td": {
            color: UI.colors.blue.toCSS(),
            fontSize: "1.5rem",
            lineHeight: 2,
            paddingRight: "2rem",
            "&:last-child": {
                paddingRight: 0
            }
        }
    },
    body: {
        backgroundColor: ({grey}: KuromojiSampleProps) =>
            UI.colors[grey ? "offWhite" : "white"].toCSS(),
        display: "inline-block",
        padding: "2rem",
        [UI.media.only("xs")]: {
            minWidth: "100%",
            whiteSpace: "nowrap"
        }
    }
});

interface KuromojiSampleProps {
    grey?: boolean;
    spaceRt?: boolean;
    children: string | JSX.Element | Array<JSX.Element | string>;
}

function KuromojiSample(props: KuromojiSampleProps) {
    const classes = useStyles(props);
    return (
        <div className={classes.root}>
            <div className={classes.body}>{props.children}</div>
        </div>
    );
}

export default memo(KuromojiSample);
